// src/pages/Hub/components/PulseFeed.js
//
// Unified activity feed — every job across every region for the active range,
// newest first. Click a row to open its detail drawer.

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2, Inbox } from 'lucide-react';
import { regionMeta, statusInfo, C } from '../theme';

export default function PulseFeed({ jobs = [], loading, onSelectJob }) {
  return (
    <div className="hub-card" style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="hub-card-title">
        <span style={{ display: 'inline-flex', width: 8, height: 8, borderRadius: '50%', background: C.green, boxShadow: `0 0 8px ${C.green}` }} />
        Live Activity {jobs.length ? `· ${jobs.length}` : ''}
      </div>

      {loading ? (
        <div className="hub-feed-loading"><Loader2 size={22} className="hub-spin" /> Loading activity…</div>
      ) : jobs.length === 0 ? (
        <div className="hub-feed-empty"><Inbox size={26} /> <span>No jobs in this range.</span></div>
      ) : (
        <div className="hub-feed">
          <AnimatePresence initial={false}>
            {jobs.slice(0, 80).map((j, i) => {
              const meta = regionMeta(j.region);
              const si = statusInfo(j.status);
              return (
                <motion.button
                  key={`${j.region}-${j.id}`}
                  className="hub-feed-row"
                  onClick={() => onSelectJob && onSelectJob(j)}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0 }}
                  transition={{ delay: Math.min(i * 0.015, 0.4) }}
                >
                  <span className="hub-feed-rdot" style={{ background: meta.color, color: meta.color }} />
                  <span className="hub-feed-main">
                    <span className="hub-feed-name">{j.clientName || 'Unknown client'}</span>
                    <span className="hub-feed-sub">
                      {[j.siteName, [j.city, j.state].filter(Boolean).join(', '), j.scheduledDate].filter(Boolean).join(' · ')}
                    </span>
                  </span>
                  <span className="hub-feed-status" style={{ color: si.color }}>{si.label}</span>
                </motion.button>
              );
            })}
          </AnimatePresence>
        </div>
      )}
    </div>
  );
}
